<app-widget-option [categories]="['INDICATORS']" [label]="'TO_DISPLAY'">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.indicators[current].display" (sendValue)="receiveDisplay($event)"></app-check>
  </div>
</app-widget-option>